import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faLink } from '@fortawesome/free-solid-svg-icons'

export default function List(props){
    return(
        <ul className={["list", props.withCheck && "withCheck", props.withDivider && "withDivider", props.withLink && "withLink", props.className].join(" ")}>
            {props.listItems.map((i, index)=>{
                return <li key={index}>
                    {props.withLink ? 
                        <a href={i.link}><FontAwesomeIcon icon={props.withCheck ? faCheck : faLink} /> {i.title}</a> 
                        : (props.withCheck && <FontAwesomeIcon icon={faCheck} />, i)}
                    </li>
            })}
        </ul>
    )
}
